/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate is the Mifflin-St Jeor equation?`)
};

const es_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan precisa es la ecuación de Mifflin-St Jeor?`)
};

const de_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genau ist die Mifflin-St Jeor-Gleichung?`)
};

const nl_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe nauwkeurig is de Mifflin-St Jeor-vergelijking?`)
};

const fr_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la précision de l'équation de Mifflin-St Jeor ?`)
};

const it_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è accurata l'equazione di Mifflin-St Jeor?`)
};

const pt_br2_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão precisa é a equação de Mifflin-St Jeor?`)
};

const pt_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão precisa é a equação de Mifflin-St Jeor?`)
};

const ja_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifflin-St Jeor方程式の精度はどの程度ですか？`)
};

const zh_bmr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifflin-St Jeor 公式的准确度如何？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq3_q", locale)
	if (locale === "en") return en_bmr_faq3_q(inputs)
	if (locale === "es") return es_bmr_faq3_q(inputs)
	if (locale === "de") return de_bmr_faq3_q(inputs)
	if (locale === "nl") return nl_bmr_faq3_q(inputs)
	if (locale === "fr") return fr_bmr_faq3_q(inputs)
	if (locale === "it") return it_bmr_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq3_q(inputs)
	if (locale === "pt") return pt_bmr_faq3_q(inputs)
	if (locale === "ja") return ja_bmr_faq3_q(inputs)
	return zh_bmr_faq3_q(inputs)
};